import React from 'react';
import { FormattedMessage } from 'react-intl';
import NumberFormat from 'react-number-format';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import PlanSwitch from '@/components/common/PlanSwitch';

const NumberFormatCustom = React.forwardRef((props, ref) => {
  const { onChange, unit, ...other } = props;

  let prefix = '';
  let suffix = '';

  if (unit === 'square-meters') {
    prefix = '';
    suffix = ' m²';
  } else if (unit === 'monetary') {
    prefix = 'R$ ';
    suffix = '';
  } else if (unit === 'credits') {
    prefix = '';
    suffix = ' créditos';
  }

  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={values => {
        onChange({
          target: {
            value: values.value ? values.floatValue : values.value,
          },
        });
      }}
      thousandSeparator="."
      decimalSeparator=","
      decimalScale={2}
      fixedDecimalScale
      prefix={prefix}
      suffix={suffix}
      isNumericString
      allowNegative={false}
    />
  );
});

NumberFormatCustom.propTypes = {
  onChange: PropTypes.func.isRequired,
  unit: PropTypes.string,
};

const RequestFormWidgetPrice = ({ disabled, id, label, onChange, options, rawErrors, readonly, required, value }) => {
  const error = !!(rawErrors && rawErrors.length > 0);
  const isDisabled = disabled || readonly || options.disabled || options.forceDisabled;

  return (
    <PlanSwitch planToHide={options.unit === 'square-meters' ? 'CONTROL' : null}>
      <div className="w-full">
        <label 
          className="inline-block text-[12px] font-bold text-[#212529] font-['Open_Sans'] mt-[0.3vh] mb-1 tracking-tight" 
          htmlFor={id}
        >
          <FormattedMessage id={label} />
          {required && <span className="text-red-500 ml-0.5">*</span>}
        </label>

        <NumberFormatCustom
          disabled={isDisabled}
          id={id}
          data-cy={id}
          unit={options.unit}
          value={value || ''}
          onChange={event => onChange(event.target.value)}
          style={{ fontWeight: 'normal', color: isDisabled ? 'rgba(0, 0, 0, 0.38)' : '#212529' }}
          className={classNames(
            "w-full rounded-[4px] !h-[37px] !px-[12px] py-[6px] text-[14px] !font-normal font-['Open_Sans'] transition-all focus:outline-none",
            {
              "bg-[#efefef] cursor-not-allowed text-[rgba(0,0,0,0.38)]": isDisabled,
              "bg-white": !isDisabled,
              "!text-[#212529]": !isDisabled,
              "border-[1px] border-solid border-[#dc3545] focus:border-[#dc3545]": error,
              "border-[1px] border-solid border-[#ced4da] focus:border-[#80bdff]": !error,
            }
          )}
        />

        {error && (
          <p className="order-form-field-error">
            {rawErrors[0]}
          </p>
        )}
      </div>
    </PlanSwitch>
  );
};

RequestFormWidgetPrice.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.object.isRequired,
  rawErrors: PropTypes.array,
  readonly: PropTypes.bool,
  required: PropTypes.bool.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

RequestFormWidgetPrice.defaultProps = {
  disabled: false,
  rawErrors: [],
  readonly: false,
  value: undefined,
};

export default RequestFormWidgetPrice;
